'use es6';

export const NONE = 0;
export const LAYOUT = 1;
export const TEMPLATE = 2;
export const JS = 2;
export const CSS = 2;
export const CUSTOM_WIDGET = 4;
export const GLOBAL_GROUP = 8;
export const GLOBAL_WIDGET = 16;
export const LAYOUT_SOURCE = 32;
export const SETTINGS = 64;
export const WELCOME = 128;
export const RAW_ASSET = 256;
export const FOLDER = 512;
export const GETTING_STARTED = 1024;